<template>
  <div class="pagenation">
    <template v-if="pageNation.count || pageNation.count === 0">
      <a :style="{visibility: !pageNation.isFirst ? 'visible' : 'hidden'}" @click="pageNation.clickFirst" role="button" class="pagenation-link first"><FontawesomeIcon :icon="['fas','angle-left']" class="icn" />最初へ</a>
      <a :style="{visibility: !pageNation.isFirst ? 'visible' : 'hidden'}" @click="pageNation.clickPrev" role="button" class="pagenation-link prev">前へ</a>
      <ul class="pagenation-list">
        <li
          v-for="page in pageNation.showNumber"
          :key="'page_' + page"
          :class="{'is-current': page === pageNation.currentPage}"
          @click="pageNation.clickPage(page)"
          role="button"
          ><a>{{page}}</a></li>
      </ul>
      <a :style="{visibility: !pageNation.isEnd ? 'visible' : 'hidden'}" @click="pageNation.clickNext" role="button" class="pagenation-link next">次へ</a>
      <a :style="{visibility: !pageNation.isEnd ? 'visible' : 'hidden'}" @click="pageNation.clickEnd" role="button" class="pagenation-link last">最後へ<FontawesomeIcon :icon="['fas','angle-right']" class="icn" /></a>
    </template>
    <FontawesomeIcon v-else :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, isRef, toRefs } from '@vue/composition-api'
import * as logicPagenation from '@/logic/common/Pagenation'

export default defineComponent({
  props: {
    count: {
      type: Number,
      default: 0
    },
    per_page: {
      default: 30
    },
    currentPage: {
      type: Number,
      default: 1
    },
    leftPage: {
      type: Number,
      default: 4
    },
    rightPage: {
      type: Number,
      default: 4
    }
  },
  setup (props, context) {

    const pageNation = logicPagenation.getPagenation(props, context)

    return {
      pageNation
    }
  }
})
</script>

<style lang="scss" scoped>
.pagenation {
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer */
  -khtml-user-select: none; /* KHTML browsers (e.g. Konqueror) */
  -webkit-user-select: none; /* Chrome, Safari, and Opera */
  -webkit-touch-callout: none; /* Disable Android and iOS callouts*/
  width: 100%;
  max-width: 920px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  text-align: center;
  &-link {
    color: $color-link;
    font-size: 1.4rem;
    width: 108px;
    @include hoverOpacity();
  }
  &-list {
    list-style: none;
    margin: 0 40px;
    flex: 0 1 auto;
    display: flex;
    justify-content: space-between;
    li {
      display: inline-block;
      padding: 0 4px;
      margin: 0 4px;
      a {
        color: $color-link;
        display: block;
        padding: 4px;
        @include hoverOpacity();
      }
      &.is-current {
        background-color: $color-link;
        border-radius: 4px;
        a {
          color: #fff;
          font-weight: bold;
        }
      }
    }
  }
  .first,.last,.prev,.next {
    padding: 4px 16px;
  }
  .first,.last {
    .icn {
      margin: 0 10px;
    }
  }
  .prev,.next {
    border-right: 1px solid $color-line;
    border-left: 1px solid $color-line;
  }
}

</style>
